"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styleKeys = ['type', 'active', 'disabled'];
/**
 * This is for use with Menu component.
 */

var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MenuItem, _React$Component);

  function MenuItem(props) {
    var _this;

    _classCallCheck(this, MenuItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItem).call(this, props));
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * The onClick handler. Similar to RC menu, user defined onClicks are
   * not allowed.
   * @param {object} e - DOM event
   *
   */


  _createClass(MenuItem, [{
    key: "onClick",
    value: function onClick(e) {
      var _this$props = this.props,
          assignedKey = _this$props.assignedKey,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          type = _this$props.type;

      if (!disabled) {
        var info = {
          event: e,
          key: assignedKey,
          keyPath: [assignedKey],
          type: type,
          item: this
        };

        if ((0, _isFunction2.default)(onClick)) {
          onClick(info);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */
      var _this$props2 = this.props,
          assignedKey = _this$props2.assignedKey,
          className = _this$props2.className,
          onClick = _this$props2.onClick,
          active = _this$props2.active,
          disabled = _this$props2.disabled,
          tooltipProps = _this$props2.tooltipProps,
          props = _objectWithoutProperties(_this$props2, ["assignedKey", "className", "onClick", "active", "disabled", "tooltipProps"]);
      /* eslint-enable */


      var styleProps = (0, _ReactElementUtils.getStyleProps)(styleKeys, this.props);

      var menuItemNode = _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-menu-item")),
        alignItems: "center",
        padding: "0px-20px",
        onClick: this.onClick
      }, styleProps, props)); // Add tooltip


      if (tooltipProps) {
        menuItemNode = _react.default.createElement(_Tooltip.default, tooltipProps, menuItemNode);
      }

      return menuItemNode;
    }
  }]);

  return MenuItem;
}(_react.default.Component);

exports.default = MenuItem;
MenuItem.propTypes = {
  /**
   * Provide additional custom class name.
   */
  className: _propTypes.default.string,

  /**
   * (For internal use) This key should be identical to key.
   */
  assignedKey: _propTypes.default.string,

  /**
   * The children elements.
   */
  children: _propTypes.default.node,

  /**
   * The onClick handler. Note: This is removed when used within a Menu component.
   */
  onClick: _propTypes.default.func,

  /**
   * To disable MenuItem events.
   */
  disabled: _propTypes.default.bool,

  /**
   * Type of item.
   */
  type: _propTypes.default.string,

  /**
   * Add tooltip to MenuItem. See Tooltip component for proper usage. Note:
   * Traditional Tooltip wrapping style does not work inside the Menu context.
   * This prop has been provided for convenience.
   */
  tooltipProps: _propTypes.default.object,

  /**
   * Item is highlighted when active.
   */
  active: _propTypes.default.bool
};